export const breadcrumb = {
  title: 'Call tracking',

  number: {
    index: 'Daftar of nomor'
  },

  integration: {
    index: 'Integrasi'
  }
};
